import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const radiusParserOptionsTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Radius Parser Options',
  key: 'radiusParserOptionsTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['roId', 'ACCESS_REQ_TIMEOUT', 'DCFD_DYNIP_PROV'],
          ['DEPLOYMENT', 'HIST_DISK_LIMIT', 'HIST_ENCRYT'],
          ['HIST_FILESIZE', 'LINKDOWNTIMEOUT', 'LISTENED_PORT'],
          ['MAX_BUFFERED_MSG', 'MAX_SESSION_NUM', 'SESSION_DUMP_INTVL'],
          ['SESSION_LIFETIME', 'SESSION_SYNC_INTVL', 'SESSION_TIMEOUT'],
          ['STATS_INTVL', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      roId: {
        label: 'Radius Parser Option ID',
        type: 'text',
        initial: '',
        readOnly: true,
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 1,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  1,
                ],
              ],
              errorMessage: 'Must be 1 or between. Please re-enter.',
            },
          ],
        },
      },
      ACCESS_REQ_TIMEOUT: {
        label: 'Access Req. Timeout',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 2,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  6,
                  60,
                ],
              ],
              errorMessage: 'Must be between 5 - 60. Please re-enter.',
            },
          ],
        },
      },
      DCFD_DYNIP_PROV: {
        type: 'select',
        label: 'DCFD Dynamic IP Provision',
        initial: 'NO',
        options: [
          {
            label: 'NO',
            value: 'NO',
          },
          {
            label: 'YES',
            value: 'YES',
          }
        ]
      },
      DEPLOYMENT: {
        label: 'Deployment',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'GENERIC',
            value: 'GENERIC',
          },
          {
            label: 'VM-NG-AFFW',
            value: 'VM-NG-AFFW',
          }
        ]
      },
      HIST_DISK_LIMIT: {
        label: 'History Disk Limit',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  2,
                  200,
                ],
              ],
              errorMessage: 'Must be between 1 - 200. Please re-enter.',
            },
          ],
        },
      },
      HIST_ENCRYT: {
        type: 'select',
        label: 'History Encryption',
        initial: 'OFF',
        options: [
          {
            label: 'ON',
            value: 'ON',
          },
          {
            label: 'OFF',
            value: 'OFF',
          }
        ]
      },
      HIST_FILESIZE: {
        label: 'History File Size',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  2,
                  200,
                ],
              ],
              errorMessage: 'Must be between 1 - 200. Please re-enter.',
            },
          ],
        },
      },
      LINKDOWNTIMEOUT: {
        label: 'Link Down Timeout',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  6,
                  180,
                ],
              ],
              errorMessage: 'Must be between 5 - 180. Please re-enter.',
            },
          ],
        },
      },
      LISTENED_PORT: {
        label: 'Listened Port',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  2,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 1 - 65535. Please re-enter.',
            },
          ],
        },
      },
      MAX_BUFFERED_MSG: {
        label: 'Max Buffer Message',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  2,
                  2000,
                ],
              ],
              errorMessage: 'Must be between 1 - 2000. Please re-enter.',
            },
          ],
        },
      },
      MAX_SESSION_NUM: {
        label: 'Max Session Number',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  2,
                  2000,
                ],
              ],
              errorMessage: 'Must be between 1 - 2000. Please re-enter.',
            },
          ],
        },
      },
      SESSION_DUMP_INTVL: {
        label: 'Session Dump Interval',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  2,
                  3600,
                ],
              ],
              errorMessage: 'Must be between 1 - 3600. Please re-enter.',
            },
          ],
        },
      },
      SESSION_LIFETIME: {
        label: 'Session Lifetime',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  16,
                  540,
                ],
              ],
              errorMessage: 'Must be between 15 - 540. Please re-enter.',
            },
          ],
        },
      },
      SESSION_SYNC_INTVL: {
        label: 'Session Synchonized Interval',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  2,
                  10,
                ],
              ],
              errorMessage: 'Must be between 2 - 10. Please re-enter.',
            },
          ],
        },
      },
      SESSION_TIMEOUT: {
        label: 'Session Timeout',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  16,
                  180,
                ],
              ],
              errorMessage: 'Must be between 15 - 180. Please re-enter.',
            },
          ],
        },
      },
      STATS_INTVL: {
        label: 'Statistics Interval',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  180,
                ],
              ],
              errorMessage: 'Must be between 0 - 180. Please re-enter.',
            },
          ],
        },
      },
    },
  }
};
